import { useState, useEffect } from '@/common'
import pca from '../assets/json/pca.json'
import { Cascader } from 'antd';

function Main(props: any) {
    const [value, setValue] = useState();
    if (props.funcBefore && typeof (props.funcBefore) == "function") props.funcBefore(pca)
    const setPCA = (val: any) => {
        setValue(val)
        props.onChange(val)
    }
    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    return (
        <Cascader options={pca} value={value} fieldNames={{ label: "text", value: "text" }} placeholder="请选择省市区" onChange={setPCA} />
    )
}

export default Main